export default "__VITE_ASSET__6941ee82__"